module.exports = __webpack_public_path__ + "img/xp_coupon_5000.e0439327.png";